import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    {...props}>
    <defs>
      <style>{'.cls-1{fill:none}.cls-6{fill:#ce2828}'}</style>
    </defs>
    <g id="Component_19_6" data-name="Component 19 6">
      <g id="Polygon_15" data-name="Polygon 15">
        <path
          id="Path_5762"
          data-name="Path 5762"
          className="cls-1"
          d="M39.21 5.22a2.24 2.24 0 0 1 3 .82 2.28 2.28 0 0 1 .3 1.11v35.4a2.23 2.23 0 0 1-2.23 2.23 2.18 2.18 0 0 1-1.11-.3L8.55 26.78a2.23 2.23 0 0 1-.81-3.05 2.1 2.1 0 0 1 .81-.81Z"
        />
        <path
          id="Path_5763"
          data-name="Path 5763"
          d="M41.44 5.22a2.22 2.22 0 0 0-2.23 0L8.55 22.92a2.22 2.22 0 0 0-.81 3 2.2 2.2 0 0 0 .81.82l30.67 17.7a2.23 2.23 0 0 0 3.05-.81 2.28 2.28 0 0 0 .29-1.12V7.15a2.19 2.19 0 0 0-1.12-1.92m2.23-3.86A6.67 6.67 0 0 1 47 7.15v35.4a6.67 6.67 0 0 1-10 5.79L6.32 30.64a6.7 6.7 0 0 1 0-11.58L37 1.36a6.67 6.67 0 0 1 6.68 0Z"
          style={{
            fill: '#e6e3d5'
          }}
        />
      </g>
      <g id="Polygon_12" data-name="Polygon 12">
        <path
          id="Path_5764"
          data-name="Path 5764"
          className="cls-1"
          d="M39.21 5.22a2.24 2.24 0 0 1 3 .82 2.28 2.28 0 0 1 .3 1.11v35.4a2.23 2.23 0 0 1-2.23 2.23 2.18 2.18 0 0 1-1.11-.3L8.55 26.78a2.23 2.23 0 0 1-.81-3.05 2.1 2.1 0 0 1 .81-.81Z"
        />
        <path
          id="Path_5765"
          data-name="Path 5765"
          d="M41.44 5.22a2.2 2.2 0 0 0-2.22 0L8.55 22.92a2.24 2.24 0 0 0 0 3.86l30.67 17.7a2.22 2.22 0 0 0 3-.81 2.19 2.19 0 0 0 .3-1.12V7.15a2.21 2.21 0 0 0-1.12-1.92m1.16-1.93a4.41 4.41 0 0 1 2.22 3.85v35.4a4.45 4.45 0 0 1-6.68 3.86L7.44 28.71a4.46 4.46 0 0 1-1.63-6.09A4.4 4.4 0 0 1 7.44 21L38.1 3.29a4.44 4.44 0 0 1 4.46 0Z"
          style={{
            fill: '#2a2729'
          }}
        />
      </g>
      <g id="Component_16_1" data-name="Component 16 1">
        <path
          id="Polygon_13"
          data-name="Polygon 13"
          d="M39.21 5.22a2.24 2.24 0 0 1 3 .82 2.28 2.28 0 0 1 .3 1.11v35.4a2.23 2.23 0 0 1-2.23 2.23 2.18 2.18 0 0 1-1.11-.3L8.55 26.78a2.23 2.23 0 0 1-.81-3.05 2.1 2.1 0 0 1 .81-.81Z"
          style={{
            fill: '#d85656'
          }}
        />
      </g>
      <g id="Group_3594" data-name="Group 3594">
        <path
          id="Path_5640"
          data-name="Path 5640"
          d="M26.44 18.22a2.35 2.35 0 0 0-.91.41l-.2.17-1 1a2.44 2.44 0 0 0-.27.29 2.28 2.28 0 0 0-.46.92 2.24 2.24 0 0 0-.07.51 2.09 2.09 0 0 0 0 .26 2 2 0 0 0 0 .26A2.39 2.39 0 0 0 24 23l2.66 2.86-1.16 1.25-.79.85-.26.28a4.69 4.69 0 0 0-.42.47 2.37 2.37 0 0 0-.4 2 2.29 2.29 0 0 0 .45.91l.17.19 1.1 1.06.19.16a2.13 2.13 0 0 0 .9.42 2.73 2.73 0 0 0 .5 0h.25a2.28 2.28 0 0 0 1.15-.45 1.45 1.45 0 0 0 .18-.17l1.26-1.25c.37-.37.76-.75 1.13-1.1l.35-.35 2.57 2.7a3.83 3.83 0 0 0 .29.28 2.38 2.38 0 0 0 3 .08c.12-.1.24-.2.35-.31l.82-.81a3.4 3.4 0 0 0 .32-.34 2.39 2.39 0 0 0 .46-1 2.48 2.48 0 0 0-.49-2.05 3.84 3.84 0 0 0-.27-.29l-.1-.1-2.53-2.43 2.78-2.92a2.28 2.28 0 0 0 0-2.82 1.63 1.63 0 0 0-.17-.2l-.94-.92a2.82 2.82 0 0 0-.36-.33 2.25 2.25 0 0 0-1.4-.45h-.24l-.25.05a2.24 2.24 0 0 0-.87.44l-3 3L29 19.42l-.28-.29a5.56 5.56 0 0 0-.43-.42 2.24 2.24 0 0 0-1.85-.49Z"
          style={{
            fill: '#8c0404'
          }}
        />
        <g id="Group_2566" data-name="Group 2566">
          <g id="Group_2565" data-name="Group 2565">
            <path
              id="Path_5641"
              data-name="Path 5641"
              className="cls-6"
              d="m32.89 30.56.7.74.36.37a3.8 3.8 0 0 0 .34.35 2.17 2.17 0 0 0 1.78.46 2.06 2.06 0 0 0 .88-.39 2.82 2.82 0 0 0 .36-.33l.37-.36.37-.36a3.89 3.89 0 0 0 .34-.36 2.22 2.22 0 0 0 .41-.88 2.18 2.18 0 0 0-.44-1.8c-.11-.12-.23-.24-.35-.35l-.37-.36-.73-.71-1.48-1.42-.13-.16.13-.14 2.83-3a2 2 0 0 0 .38-1.7 2.19 2.19 0 0 0-.38-.8l-.15-.16-.18-.18-.37-.36-.36-.36a3.49 3.49 0 0 0-.35-.32 2 2 0 0 0-1.23-.4h-.22l-.22.05a1.94 1.94 0 0 0-.77.39L31.52 21l-.26.26L31 21l-1.44-1.46-.72-.73c-.24-.24-.48-.51-.7-.7a2 2 0 0 0-1.66-.42 2 2 0 0 0-.81.36l-.17.15-.19.18-.36.35-.37.36c-.12.11-.23.22-.34.34a2.26 2.26 0 0 0-.41.82 3.47 3.47 0 0 0-.06.45v.24a1.85 1.85 0 0 0 0 .23 2 2 0 0 0 .38.85L27 25c-.45.5-.92 1-1.38 1.5l-.7.74c-.22.25-.49.5-.67.74a2.17 2.17 0 0 0-.36 1.76 2.05 2.05 0 0 0 .4.81 1.29 1.29 0 0 0 .16.17l.18.17.36.36.36.35.18.18.18.14a2 2 0 0 0 .8.37 2.2 2.2 0 0 0 .44.05h.22a2 2 0 0 0 1-.42l.17-.15.17-.17.36-.37.72-.71c.48-.49 1-1 1.46-1.43l.21-.2.2.2Z"
            />
            <path
              id="Path_5642"
              data-name="Path 5642"
              className="cls-6"
              d="M35.67 32.78a2.37 2.37 0 0 1-1.55-.57 2.47 2.47 0 0 1-.28-.28l-2.57-2.69-.35.34-1.13 1.1-1.26 1.26a1.45 1.45 0 0 1-.18.17 2.26 2.26 0 0 1-1.14.47H27a1.67 1.67 0 0 1-.5-.05 2.3 2.3 0 0 1-.9-.41l-.23-.12-1.1-1-.18-.19a2.36 2.36 0 0 1-.09-2.97 6.29 6.29 0 0 1 .43-.47l.26-.28.79-.85c.38-.4.77-.82 1.15-1.25L24 22.13a2.28 2.28 0 0 1-.44-1 2.06 2.06 0 0 1 0-.26 1 1 0 0 1 0-.25 2.24 2.24 0 0 1 .06-.52 2.42 2.42 0 0 1 .46-.92 3.7 3.7 0 0 1 .28-.28l1-1 .2-.17a2.27 2.27 0 0 1 2.79.07c.14.12.28.27.43.42a3.83 3.83 0 0 0 .28.29l2.23 2.27 3-3a2.17 2.17 0 0 1 .87-.44l.24-.05h.25a2.18 2.18 0 0 1 1.35.51l.36.33.93.91c.06.07.12.13.17.2a2.28 2.28 0 0 1 0 2.82L35.68 25l2.52 2.43.1.1a3.83 3.83 0 0 1 .28.29 2.48 2.48 0 0 1 .49 2.05 2.41 2.41 0 0 1-.47 1 2.5 2.5 0 0 1-.31.34l-.82.81a3.38 3.38 0 0 1-.35.31 2.42 2.42 0 0 1-1.44.48Zm-4.39-4.27 2.94 3.07.24.24a1.94 1.94 0 0 0 1.57.41 1.84 1.84 0 0 0 .77-.34l.3-.27.82-.8.27-.29a1.86 1.86 0 0 0 .36-.78 2 2 0 0 0-.38-1.62c-.08-.08-.15-.16-.24-.24l-.1-.1-.36-.36L34.94 25l.31-.32 2.82-2.95a1.78 1.78 0 0 0 .32-1.48 1.73 1.73 0 0 0-.33-.7l-.13-.15-.93-.91-.31-.28a1.7 1.7 0 0 0-1.07-.35h-.38a1.64 1.64 0 0 0-.66.33l-3.32 3.32-2.6-2.63-.29-.3a4.75 4.75 0 0 0-.4-.39 1.74 1.74 0 0 0-1.44-.36 1.77 1.77 0 0 0-.7.31 1 1 0 0 0-.15.13l-1 1a1.88 1.88 0 0 0-.24.25 1.91 1.91 0 0 0-.36.71 1.83 1.83 0 0 0-.05.4 1.48 1.48 0 0 0 0 .21.64.64 0 0 0 0 .2 1.83 1.83 0 0 0 .33.74l3 3.22-.18.2c-.43.48-.87 1-1.3 1.42l-.78.83c-.08.1-.18.2-.27.3a3.79 3.79 0 0 0-.38.42 1.86 1.86 0 0 0-.31 1.55 1.75 1.75 0 0 0 .35.71.93.93 0 0 0 .14.14l1.08 1.06a1.58 1.58 0 0 0 .15.12 1.88 1.88 0 0 0 .7.33 2.45 2.45 0 0 0 .38 0h.39a1.64 1.64 0 0 0 .69-.33.86.86 0 0 0 .14-.13l1.26-1.26 1.13-1.11Z"
            />
          </g>
        </g>
        <g id="Group_2567" data-name="Group 2567">
          <path
            id="Path_5643"
            data-name="Path 5643"
            d="m32.91 30.56.7.74.36.37a3.8 3.8 0 0 0 .34.35 2.17 2.17 0 0 0 1.78.46 2.06 2.06 0 0 0 .88-.39 2.82 2.82 0 0 0 .36-.33l.37-.36.36-.36a2.31 2.31 0 0 0 .34-.36 2.11 2.11 0 0 0 .42-.88 2.22 2.22 0 0 0-.44-1.8l-.38-.4-.37-.35-.73-.71-1.48-1.42-.1-.12.13-.14 2.83-3a2.06 2.06 0 0 0 .38-1.7 2.19 2.19 0 0 0-.38-.8l-.15-.16-.13-.15-.37-.36-.37-.37a2.5 2.5 0 0 0-.34-.31 2 2 0 0 0-1.23-.4h-.44a2 2 0 0 0-.77.4L31.54 21l-.26.26L31 21l-1.43-1.46-.72-.73c-.24-.24-.48-.51-.7-.7a2 2 0 0 0-1.66-.42 2 2 0 0 0-.81.36l-.18.15-.18.17-.37.36-.36.36a3.64 3.64 0 0 0-.34.34 2.3 2.3 0 0 0-.41.81 3.62 3.62 0 0 0-.06.46v.24a2.23 2.23 0 0 0 0 .23 2 2 0 0 0 .38.85L27 25l-1.38 1.5-.7.74a9 9 0 0 0-.67.74 2.09 2.09 0 0 0-.36 1.76 2.05 2.05 0 0 0 .4.81l.16.17.18.17.36.36.36.35.18.17.18.15a2 2 0 0 0 .8.37 2.12 2.12 0 0 0 .44 0h.22a2 2 0 0 0 1-.42l.16-.15.18-.18.36-.36.72-.72c.48-.48 1-.95 1.46-1.42l.2-.2.2.2Z"
            style={{
              fill: '#fff'
            }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgComponent;
